// extracted by mini-css-extract-plugin
export default {"tool":"style_tool__0DBU8","react":"style_react__pY2k-","rotate":"style_rotate__oGlUu"};